import React from 'react';
import { Bus, HeartHandshake, Route, MessageCircle, Shield, Truck } from 'lucide-react';
import { coreServices } from '../mock';

const ServicesSection = () => {
  const iconMap = {
    Bus: Bus,
    HeartHandshake: HeartHandshake,
    Route: Route,
    Truck: Truck,
    MessageCircle: MessageCircle,
    Shield: Shield
  };

  return (
    <section className="py-24 bg-[#F7F9FB] relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-gradient-to-br from-[#0077BE]/5 to-[#00B4D8]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#0B0F14] mb-6">
            Core Services
          </h2>
          <p className="text-xl text-[#5F6B7A] max-w-3xl mx-auto">
            Comprehensive support designed for students with specialized needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {coreServices.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group p-8 rounded-3xl backdrop-blur-xl bg-white/60 border border-white/50 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 hover:bg-white/80"
              >
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#0077BE] to-[#00B4D8] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-[#0B0F14] mb-4">
                  {service.title}
                </h3>
                <p className="text-[#5F6B7A] leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
